import React from "react";

import ActivityHistoryButtonIcon from "@common/assets/images/details-pane-icons/activity-history-button-icon.svg";

import * as Styled from "./ActivityHistoryButton.styles";

interface ActivityHistoryButtonProps {
  to: string;
}
const ActivityHistoryButton = ({ to }: ActivityHistoryButtonProps) => {
  return (
    <Styled.ActivityHistoryButton to={to}>
      <Styled.Image src={ActivityHistoryButtonIcon} />
      <Styled.Text>{"Activity history"}</Styled.Text>
    </Styled.ActivityHistoryButton>
  );
};

export { ActivityHistoryButton };
